/* eslint-disable no-restricted-syntax */
/* eslint-disable no-plusplus */
/* eslint-disable function-paren-newline */
/* eslint-disable no-confusing-arrow */
/* eslint-disable no-misleading-character-class */
/* eslint-disable no-lone-blocks */
import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Typography,
  Link,
  CardActionArea,
  CardMedia,
  Button,
} from "@mui/material";
import { ITemplate } from "../ITemplateDetail";
import { getJiraUrl } from "../../../constants";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import GTranslateIcon from "@mui/icons-material/GTranslate";
import * as Assets from "../../../components/Icon/assets";
import { useCookies, Cookies } from "react-cookie";
import moment from "moment";
import styled from "styled-components";

type FileProps = {
  templates: ITemplate;
  wRatio: string;
  hRatio: string;
};

export const File = ({ templates, wRatio, hRatio }: FileProps) => {
  const autoSizing = () => {
    return {
      width: `${(Number(wRatio) / Number(hRatio)) * 255}px`,
      height: "255px ",
      outline: "none",
    };
  };

  const gCookie = new Cookies();
  const getCookie = (item: string) => {
    return gCookie.get(item);
  };
  const [cookies, setCookie, removeCookie] = useCookies();
  const expires = moment().add("100", "y").toDate();
  const [forbidden, setForbidden] = useState(templates.forbiddenWords);

  const splitUrl = (templateId: any, url: string, type?: string) => {
    let urlArr = url.split(`${templateId}/`);
    return !type ? urlArr[1] : urlArr[1].replace("reEncoding_", "");
  };

  const originalUrl = (item: string, type: string) => {
    if (item.includes("user_projects_origin")) return item;

    if (type === "video") {
      const url = item
        .replace("user_projects", "user_projects_origin")
        .replace("reEncoding_", "");
      return url;
    } else if (type === "file") {
      const url = item.replace("user_projects", "user_projects_origin");
      return url;
    }
  };

  const filterInspect = (item: any, field: string) => {
    const filterResult = item.filter((i: any) => i.includes(field));
    let result = "";

    if (filterResult.length > 0) result = "reject";
    else result = "pass";

    return result;
  };

  const keywordString = (item: any) => {
    const forbiddenKeywords = item.map((word: any) => word.keyword);

    return forbiddenKeywords.join(", ");
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter" || event.key === " " || event.key === "f") {
      // Perform your action when Enter or Space key is pressed
      console.log("Enter or Space key pressed");
    } else if (event.key === "ArrowLeft") {
      // Handle left arrow key press
      console.log("Left arrow key pressed");
    } else if (event.key === "ArrowRight") {
      // Handle right arrow key press
      console.log("Right arrow key pressed");
    }
  };

  const userLang = navigator.language || "en";

  const encodeString = (text: string) => {
    return encodeURIComponent(text);
  };

  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [speed, setSpeed] = useState(getCookie("videoSpeed") || 1);

  const wordMatching = (text: string, forbiddenWords: any) => {
    const highlightForbiddenWords = (text: string, forbiddenWords: any) => {
      let result = [];
      let startIndex = 0;

      for (let i = 0; i < text.length; i++) {
        for (const { keyword } of forbiddenWords) {
          if (
            text.slice(i, i + keyword.length).toLowerCase() ===
            keyword.toLowerCase()
          ) {
            if (startIndex !== i) {
              result.push(text.slice(startIndex, i));
            }
            result.push(
              <b key={i}>
                <span style={{ color: "red" }}>
                  {text.slice(i, i + keyword.length)}
                </span>
              </b>
            );
            startIndex = i + keyword.length;
            i += keyword.length - 1;
            break;
          }
        }
      }

      if (startIndex < text.length) {
        result.push(text.slice(startIndex));
      }

      return result;
    };

    return (
      <div key="forbidden">
        {highlightForbiddenWords(text, forbiddenWords)}
        &nbsp;
        <ContentCopyIcon
          sx={{ fontSize: "large", cursor: "pointer" }}
          onClick={() => {
            templates.translations[0].description &&
              navigator.clipboard.writeText(
                templates.translations[0].description.trim()
              );
          }}
        />
        &nbsp; &nbsp; &nbsp;
        <Link
          href={`https://translate.google.co.kr/?sl=auto&hl=${userLang}&text=${encodeString(
            templates.translations[0].description
          )}`}
          target="_blank"
        >
          <GTranslateIcon
            sx={{ fontSize: "large", cursor: "pointer", color: "#6666ff" }}
          />
        </Link>
      </div>
    );
  };

  const handleSpeedChange = (newSpeed: number) => {
    if (videoRef.current) {
      setCookie("videoSpeed", newSpeed, { path: "/", expires });
      videoRef.current.playbackRate = newSpeed;
      setSpeed(newSpeed);
    }
  };

  useEffect(() => {
    const savedSpeed = getCookie("videoSpeed") || 1;
    if (savedSpeed) {
      handleSpeedChange(Number(savedSpeed));
    }
  }, []);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          m: "10px",
          mt: "-20px",
          mb: "-33px",
        }}
        minHeight={60}
      >
        <Box sx={{ width: "24px", mr: "8px" }} />
        <Box width={"30%"}>
          <Typography fontWeight={500}>Description (C)</Typography>
        </Box>

        <Box>
          <Typography minWidth={"20%"} maxWidth={650}>
            {forbidden ? (
              wordMatching(
                templates.translations[0].description.trim(),
                forbidden
              )
            ) : (
              <>
                {templates.translations[0].description.trim()}{" "}
                <ContentCopyIcon
                  sx={{ fontSize: "large", cursor: "pointer" }}
                  onClick={() => {
                    templates.translations[0].description &&
                      navigator.clipboard.writeText(
                        templates.translations[0].description.trim()
                      );
                  }}
                />
                &nbsp; &nbsp; &nbsp;
                <Link
                  href={`https://translate.google.co.kr/?sl=auto&hl=${userLang}&text=${encodeString(
                    templates.translations[0].description
                  )}`}
                  target="_blank"
                >
                  <GTranslateIcon
                    sx={{
                      fontSize: "large",
                      cursor: "pointer",
                      color: "#6666ff",
                    }}
                  />
                </Link>
              </>
            )}
          </Typography>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          m: "10px",
          pt: "5px",
          mb: "-5px",
        }}
        minHeight={60}
      >
        <Box sx={{ width: "24px", mr: "8px" }} />
        <Box width={"30%"}>
          <Typography fontWeight={500}>Forbidden Word</Typography>
        </Box>

        {forbidden && (
          <Box>
            <Typography minWidth={"20%"} maxWidth={650}>
              <b style={{ color: "red" }}>{keywordString(forbidden)}</b>
            </Typography>
          </Box>
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          m: "10px",
          mt: "-25px",
        }}
        minHeight={60}
      >
        <Box sx={{ width: "24px", mr: "8px" }} />
        <Box width={"30%"}>
          <Typography fontWeight={500}>Project File</Typography>
        </Box>
        <Box sx={{ mt: "30px" }}>
          <Typography minWidth={"20%"} maxWidth={650}>
            {templates.jiraTicket ? (
              <Link
                href={getJiraUrl() + "/" + templates.jiraTicket}
                target="_blank"
              >
                {templates.jiraTicket}
              </Link>
            ) : (
              <Link href={originalUrl(templates.filePath, "file")}>
                {splitUrl(templates.templateId, templates.filePath, "file")}
                {" (Raw)"}
              </Link>
            )}
          </Typography>
          <Typography minWidth={"20%"} maxWidth={650}>
            <Link href={templates.filePath}>
              {splitUrl(templates.templateId, templates.filePath)}
              {" (Optimization)"}
            </Link>
            &nbsp;
            {templates.subscriberAtUpload && (
              <img
                src={Assets.Subscribe}
                alt="time"
                style={{ width: 16, height: 16 }}
              />
            )}
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          m: "10px",
          mt: "-285px",
        }}
        minHeight={60}
      >
        <Box sx={{ width: "24px", mr: "8px" }} />
        <Box width={"30%"}>
          <Typography fontWeight={500}>Video (Space)</Typography>
        </Box>
        <Box sx={{ mt: "285px" }}>
          <Typography minWidth={"20%"} maxWidth={650}>
            {templates.jiraTicket ? (
              <Link
                href={getJiraUrl() + "/" + templates.jiraTicket}
                target="_blank"
              >
                {templates.jiraTicket}
              </Link>
            ) : (
              <Link href={originalUrl(templates.videoPath, "video")}>
                {splitUrl(templates.templateId, templates.videoPath, "video")}
                {" (Raw)"}
              </Link>
            )}
          </Typography>
          <Typography minWidth={"20%"} maxWidth={650}>
            <Link href={templates.videoPath}>
              {splitUrl(templates.templateId, templates.videoPath)}
              {" (Optimization)"}
            </Link>
            &nbsp;
            {templates.subscriberAtUpload && (
              <img
                src={Assets.Subscribe}
                alt="time"
                style={{ width: 16, height: 16 }}
              />
            )}
          </Typography>
          <CardActionArea>
            <CardMedia
              sx={autoSizing}
              component="video"
              id="video"
              controls
              src={templates.videoPath}
              tabIndex={0}
              onKeyDown={handleKeyDown}
              ref={videoRef}
            />
          </CardActionArea>
          Playback Speed
          {[1, 2, 3, 4].map((speedOption) => (
            <Button
              sx={{
                pl: "0px",
                pr: "0px",
                minWidth: "60px !important",
                width: "60px !important",
                "&&.Mui-disabled": {
                  color: "#6750A4",
                  fontSize: "23px",
                },
              }}
              key={speedOption}
              onClick={() => handleSpeedChange(speedOption)}
              disabled={speed === speedOption}
            >
              {speed === speedOption ? (
                <b>{speedOption + "x"}</b>
              ) : (
                `${speedOption}x`
              )}
            </Button>
          ))}
        </Box>
      </Box>
    </>
  );
};
